<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <div class="pa-0">
        <FacturaE ref="facturae" v-on:onfacturagenerada="onfacturagenerada" v-on:onclose="dialog = !dialog" />
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
  import FacturaE from '@/views/recibos/EmitFacturaEViewform.vue';
  export default {
    data() {
      return {
        dialog: false,
      };
    },
    components: { FacturaE },
    methods: {
      async showThisView(recibo, estudiante, sucursal, clearcli,programa) {
        window.console.log("hhhx",programa);
        this.dialog = true;
        let vue = this;
        setTimeout(() => {
          vue.$refs.facturae.showThisView(recibo, estudiante, sucursal, clearcli, programa); 
          vue.$refs.facturae.setLoadPuntosBySucursal(sucursal.id, sucursal);
        }, 500);
      },
      onfacturagenerada(ventaid, xrecibo, data, factura) {
        this.$emit('open', ventaid, xrecibo, data, factura); 
        this.dialog = false;
      },
    },
    mounted() {},
  };
</script>

<style></style>
